import { MainPageContainer } from '@leagueplatform/web-common-components';
import { HeroSection } from 'components/hero-section/hero-section.component';
import { StackLayout, ParagraphText } from '@leagueplatform/genesis-core';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { AddressInformationComponent } from 'components/profile-settings/address-information/address-information.component';
import { CommunicationComponent } from 'components/profile-settings/communication-preference/communication.component';
import { PersonalInfoComponent } from 'components/profile-settings/personal-Info.component';
import { ContactInfoComponent } from 'components/profile-settings/contact-info.component';
import { DetailSection } from 'components/profile-settings/detail-section.component';
import { FullPageLoadingSpinner } from 'components/loaders/full-page-loading-spinner.component';
import { useProfileSettings } from 'hooks/use-profile-settings.hook';

const ProfileSettingsPage = () => {
  const {
    data,
    initialOptions,
    isLoading,
    fetchErrorCode,
    handlePersonalInfoSave,
    handleAddressInfoSave,
    handleCommunicationSave,
    handleGoBack,
    formatMessage,
  } = useProfileSettings();

  useDocumentTitle(formatMessage({ id: 'STR_PROFILE_SETTINGS' }));

  // Graceful failure handling for address data
  const mailingAddress = data?.mailingAddress || {};
  const homeAddress = data?.homeAddress || {};

  if (isLoading) {
    return <FullPageLoadingSpinner />;
  }

  return (
    <MainPageContainer width="100%">
      <HeroSection
        title={formatMessage({ id: 'STR_PROFILE_SETTINGS' })}
        goBack={handleGoBack}
      />
      <StackLayout>
        <StackLayout
          css={{
            maxWidth: 830,
            width: '100%',
            marginY: '$four',
            '@desktop': {
              padding: '40px 32px',
            },
          }}
        >
          <PersonalInfoComponent
            firstName={data?.userProfile?.firstName || ''}
            lastName={data?.userProfile?.lastName || ''}
            preferredFirstName={data?.userProfile?.preferredFirstName ?? ''}
            onSave={handlePersonalInfoSave}
            hasSubtitle
          />
          <AddressInformationComponent
            mailingAddress={mailingAddress}
            homeAddress={homeAddress}
            onSave={handleAddressInfoSave}
          />
          {fetchErrorCode === 500 ? (
            <>
              <DetailSection
                title="STR_CONTACT_INFORMATION"
                contents={[]}
                hideButtons
                alwaysEdit
                renderEditContent={() => (
                  <ParagraphText>
                    {formatMessage({ id: 'STR_PROFILE_SECTION_LOAD_ERROR' })}
                  </ParagraphText>
                )}
              />
              <DetailSection
                title="STR_COMMUNICATIONS"
                contents={[]}
                hideButtons
                alwaysEdit
                renderEditContent={() => (
                  <ParagraphText>
                    {formatMessage({ id: 'STR_PROFILE_SECTION_LOAD_ERROR' })}
                  </ParagraphText>
                )}
              />
            </>
          ) : (
            <>
              <ContactInfoComponent
                primaryPhoneNumber={data?.phoneNumber || ''}
                email={data?.email || ''}
              />
              <CommunicationComponent
                title="STR_COMMUNICATIONS"
                initialOptions={initialOptions}
                onSave={handleCommunicationSave}
              />
            </>
          )}
        </StackLayout>
      </StackLayout>
    </MainPageContainer>
  );
};

export default ProfileSettingsPage;
